
import { defineComponent } from 'vue'
import OuterTop from '@/components/organisms/dms/OuterTop/OuterTop.vue'
export default defineComponent({
  components: {
    OuterTop
  }
})
